/* global DocumentTouch */

/**
 * Feature detection for touch events.
 *
 * This was pulled from  Modernizr and then adapted to work when running in a node environment:
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js
 */
export const TOUCH_SUPPORTED = (() => {
  if (typeof window !== 'undefined') {
    if ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
      return true;
    }
  }

  return false;
})();



/** WEBPACK FOOTER **
 ** ./src/css/features.js
 **/